import { format, unwrapFunctionStore } from 'svelte-i18n';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

const $format = unwrapFunctionStore(format);

export const changingHtmlCss = {
  element: '#signature-editor > div.page-content > div > div.editor-left-pane > div:nth-child(2) > div > div > button',
  popover: {
    title: $format('label.TOURS.STUDIO.EDIT.HTML_CSS.TITLE'),
    description: $format('label.TOURS.STUDIO.EDIT.HTML_CSS.DESCRIPTION'),
    onNextClick: () => {
      const editHtmlButton = document.querySelector(
        '#signature-editor > div.page-content > div > div.editor-left-pane > div:nth-child(2) > div > div > button'
      );

      if (editHtmlButton) {
        editHtmlButton.click();

        setTimeout(() => {
          GLOBAL_DRIVER_OBJECT.moveNext();
        }, 50);
      }
    }
  }
};
